export default {
    dataDefinition: {
        bank: {
            panel1: [
                { tr: 'F/K', en: 'Price Proceeds', value: 'priceProceeds', type: 'number' },
                { tr: 'PD/DD', en: 'Market Value/Book Value', value: 'marValBookVal', type: 'number' },
                { tr: 'PD/Mevduat', en: 'Market Value/Depth', value: 'marValDep', type: 'number' },
                { tr: 'PD/Net Faiz Gelirleri', en: 'Market Value/Net Interest Income', value: 'marValIntInc', type: 'number', tr_alternative: 'PD/Net Kar Payı Gelirleri', en_alternative: 'Market Value/Net Profit Share Income', },
                { tr: 'PD/Krediler', en: 'Market Value/Credits', value: 'marValCre', type: 'number' }
            ],
            panel2: [
                { tr: 'Faiz Gelirleri', en: 'Interest Income', value: 'intInc', tr_alternative: 'Kar Payı Gelirleri', en_alternative: 'Profit Share Income' },
                { tr: 'Faiz Giderleri', en: 'Interest Expenses', value: 'intExp',  tr_alternative: 'Kar Payı Giderleri', en_alternative: 'Profit Share Expenses', isNegativeValue: true, isOpposite: true },
                { tr: 'Net Ücret Komisyon Gelirleri', en: 'Net Commission Income', value: 'netComInc' },
                { tr: 'Net Faaliyet Karı/(Zararı)',  en: 'Net Operation Profit', value: 'netOperProfit' },
                { tr: 'Net Kar', en: 'Net Profit', value: 'netProfit' }
            ],
            panel3: [
                { tr: 'Finansal Varlıklar(Net)', en: 'Financial Assets', value: 'finAssets' },
                { tr: 'Krediler', en: 'Credits', value: 'credit' },
                { tr: 'Mevduatlar', en: 'Deposits', value: 'deposit' },
                { tr: 'Beklenen Zarar Karşılıkları (Toplam)', en: 'Expected Loss Provisions', value: 'exLossPro', isNegativeValue: true, isOpposite: true },
                { tr: 'A.O. Özkaynaklar', en: 'Equity', value: 'equity' }

            ],
            panel4: [
                { tr: 'Net Kar/Faiz Geliri', en: 'Net Profit/Interest Income', value: 'netProIntInc', tr_alternative: 'Net Kar/Kar Payı Geliri', en_alternative: 'Net Profit/Profit Share Income' },
                { tr: 'Net Faiz Geliri/Krediler', en: 'Net Interest Income/Credits', value: 'netIntIncCre', tr_alternative: 'Net Kar Payı Geliri/Krediler', en_alternative: 'Net Profit Share Income/Credits' },
                { tr: 'Krediler/Varlıklar', en: 'Credits/Assets', value: 'creAssets' },
                { tr: 'Mevduat/Kaynaklar', en: 'Deposits/Resources', value: 'depRes' },
                { tr: 'Özkaynak/Kaynaklar', en: 'Equity/Resources', value: 'eqRes' }
            ],
            panel5: [
                { tr: 'Hisse Başı Kar', en: 'Earnings per Share', value: 'earPerShare', type: 'number' },
                { tr: 'Defter Değeri', en: 'Book Value', value: 'bookVal', type: 'number' },
                { tr: 'Ort. Aktif Karlılığı', en: 'Avg. Return on Assets', value: 'activeProfit' },
                { tr: 'Ort. Özkaynak Karlılığı', en: 'Avg. Return on Equity', value: 'equityProfit' },
                { tr: 'YPP/PD', en: 'CP/MV', value: 'curPosMarVal' }
            ],
            charts: [
                { tr: 'Çeyreklik Net Kâr', en: 'Quarter Net Profit', tr_half: '6 Aylık Net Kâr', en_half: '6 Months Net Profit', tr_yearly: 'Net Kâr', en_yearly: 'Net Profit', value: 'qNetProfitAdjusted' },
                { tr: 'Çeyreklik Krediler', en: 'Quarter Credits', tr_half: '6 Aylık Krediler', en_half: '6 Months Credits', tr_yearly: 'Krediler', en_yearly: 'Credits', value: 'qCredit' },
                { 
                    tr: 'Çeyreklik Net Faiz Gelirleri',
                    en: 'Quarter Net Interest Income',
                    tr_half: '6 Aylık Net Faiz Gelirleri',
                    en_half: '6 Months Net Interest Income',
                    value: 'qNetIntInc',
                    tr_alternative: 'Çeyreklik Net Kâr Payı Gelirleri',
                    en_alternative: 'Quarter Net Profit Share Income',
                    tr_half_alternative: '6 Aylık Net Kâr Payı Gelirleri',
                    en_half_alternative: '6 Months Net Profit Share Income',
                    tr_yearly: 'Net Faiz Gelirleri',
                    en_yearly: 'Net Interest Income', },
            ]
        },
        factoring: {
            panel1: [
                { tr: 'F/K', en: 'Price Proceeds', value: 'priceProceeds', type: 'number' },
                { tr: 'PD/DD', en: 'Market Value/BookValue', value: 'marValBookVal', type: 'number' },
                { tr: 'Temettü Verimi', en: 'Dividend Yield', value: 'dividendYield' }
            ],
            panel2: [
                { tr: 'Faktoring Gelirleri', en: 'Factoring Income', value: 'facInc' },
                { tr: 'Kiralama Gelirleri', en: 'Leasing Income', value: 'leaInc' },
                { tr: 'Brüt Kar', en: 'Gross Profit', value: 'grossProfit' },
                { tr: 'Net Faaliyet Karı', en: 'Net Operation Profit', value: 'netOperProfit' },
                { tr: 'Net Kar', en: 'Net Profit', value: 'netProfit' }
            ],
            panel3: [
                { tr: 'Faktoring Alacakları', en: 'Factoring Receivables', value: 'facRec'},
                { tr: 'Kiralama Alacakları', en: 'Leasing Receivables', value: 'leaRec'},
                { tr: 'Alınan Krediler', en: 'Received Loans', value: 'recLoan' },
                { tr: 'İhraç Edilen Menkul Kıymetler', en: 'Issued Securities', value: 'issSec' },
                { tr: 'Özkaynaklar', en: 'Equity', value: 'equity' }
            ],
            panel4: [
                { tr: 'Brüt Kar Marjı', en: 'Gross Margin', value: 'grossMargin' },
                { tr: 'Faaliyet Kar Marjı', en: 'Operation Margin', value: 'operMargin' },
                { tr: 'Net Kar Marjı', en: 'Net Profit Margin', value: 'netMargin' },
                { tr: 'Alacaklar/Varlıklar', en: 'Receivables/Assets', value: 'recAssets' },
                { tr: 'Özkaynak/Kaynaklar', en: 'Equity/Resources', value: 'eqRes' }
            ],
            panel5: [
                { tr: 'Hisse Başı Kar', en: 'Earning per Share', value: 'earPerShare', type: 'number' },
                { tr: 'Defter Değeri', en: 'Book Value', value: 'bookVal', type: 'number' },
                { tr: 'Ort. Aktif Karlılığı', en: 'Avg. Return on Assets', value: 'activeProfit' },
                { tr: 'Ort. Özkaynak Karlılığı', en: 'Avg. Return on Equity', value: 'equityProfit' },
                { tr: 'YPP/PD', en: 'CP/MV', value: 'curPosMarVal' }
            ],
            charts: [
                { tr: 'Çeyreklik Net Kâr', en: 'Quarter Net Profit', tr_half: '6 Aylık Net Kâr', en_half: '6 Months Net Profit', tr_yearly: 'Net Kâr', en_yearly: 'Net Profit', value: 'qNetProfitAdjusted' },
                { tr: 'Çeyreklik Faktoring Ve Kiralama Alacakları', en: 'Quarter Factoring and Leasing Receivables', tr_half: '6 Aylık Faktoring Ve Kiralama Alacakları', en_half: '6 Months Factoring and Leasing Receivables', tr_yearly: 'Faktoring Ve Kiralama Alacakları', en_yearly: 'Factoring and Leasing Receivables', value: 'qFacLeaRec' },
                { tr: 'Çeyreklik Faktoring Ve Kiralama Gelirleri', en: 'Quarter Factoring and Leasing Income', tr_half: '6 Aylık Faktoring Ve Kiralama Gelirleri', en_half: '6 Months Factoring and Leasing Income', tr_yearly: 'Faktoring Ve Kiralama Gelirleri', en_yearly: 'Factoring and Leasing Income', value: 'qFacLeaInc' }
            ],
        },
        insurance: {
            panel1: [
                { tr: 'F/K', en: 'Price Proceeds', value: 'priceProceeds', type: 'number' },
                { tr: 'PD/DD', en: 'Market Value/BookValue', value: 'marValBookVal', type: 'number' },
                { tr: 'Likit Aktif Oranı', en: 'Liquid Asset Ratio', value: 'liqAssetsRatio', type: 'number' },
                { tr: 'Temettü Verimi', en: 'Dividend Yield', value: 'dividendYield' },
                { tr: '', en: '', value: '', isEmpty: true }
            ],

            panel2: [
                { tr: 'Teknik Gelir', en: 'Technical Income', value: 'tecInc' },
                { tr: 'Teknik Gider', en: 'Technical Expenses', value: 'tecExp', isNegativeValue: true, isOpposite: true },
                { tr: 'Yatırım Gelirleri', en: 'Investing Income', value: 'invInc' },
                { tr: 'Yatırım Giderleri', en: 'Investing Expenses', value: 'invExp', isNegativeValue: true, isOpposite: true  },
                { tr: 'Net Kar', en: 'Net Profit', value: 'netProfit' }
            ],

            panel3: [
                { tr: 'Kısa Vadeli Finansal Yatırımlar', en: 'Short Term Financial Investments', value: 'shortFinInvAssets' },
                { tr: 'Kısa Vadeli Esas Faaliyetlerinden Alacaklar', en: 'Operation Receivables', value: 'operRec' },
                { tr: 'Kısa Vadeli Sigortacılık Teknik Karşılıkları', en: 'Insurance Technical Provisions', value: 'insTecProv' },
                { tr: 'Kısa Vadeli Esas Faaliyetlerden Borçlar ', en: 'Operation Liabilities', value: 'operLiab', isOpposite: true },
                { tr: 'A.O. Özkaynaklar', en: 'Equity', value: 'equity' }
            ],
            panel4: [
                { tr: 'Cari Oran', en: 'Current Rate', value: 'curRate', type: 'number' },
                { tr: 'Teknik Denge/Gelir', en: 'Technical Balance/Income', value: 'tecBalInc', type: 'number' },
                { tr: 'Sigortacılık Teknik Karşılık/Özkaynak', en: 'Returns/Equity', value: 'retEquity', type: 'number' },
                { tr: 'Kısa Vadeli Finansal Yatırımlar/Varlıklar', en: 'Short Term Financial Investments/Assets', value: 'shorFinInvAssets' },
                { tr: (width) => width >= 960 && width <= 1300 ? 'Özkaynaklar/ Kaynaklar' : 'Özkaynaklar/Kaynaklar', en: 'Equity/Resources', value: 'eqRes'}
            ],

            panel5: [
                { tr: 'Hisse Başı Kar', en: 'Earning per Share', value: 'earPerShare', type: 'number' },
                { tr: 'Defter Değeri', en: 'Book Value', value: 'bookVal', type: 'number' },
                { tr: 'Ort. Aktif Karlılığı', en: 'Avg. Return on Assets', value: 'activeProfit' },
                { tr: 'Ort. Özkaynak Karlılığı', en: 'Avg. Return on Equity', value: 'equityProfit' },
                { tr: 'YPP/PD', en: 'CP/MV', value: 'curPosMarVal'}
            ],
            charts: [
                { tr: 'Çeyreklik Net Kâr', en: 'Quarter Net Profit', tr_half: '6 Aylık Net Kâr', en_half: '6 Months Net Profit', tr_yearly: 'Net Kâr', en_yearly: 'Net Profit', value: 'qNetProfitAdjusted' },
                { tr: 'Çeyreklik Yatırım Geliri & Gideri(Net)', en: 'Quarter Investment Income and Expenses', tr_half: '6 Aylık Yatırım Geliri & Gideri(Net)', en_half: '6 Months Investment Income and Expenses', tr_yearly: 'Yatırım Geliri & Gideri(Net)', en_yearly: 'Investment Income and Expenses', value: 'qInvIncExp' },
                { tr: 'Çeyreklik Teknik Denge', en: 'Quarter Technical Balance', tr_half: '6 Aylık Teknik Denge', en_half: '6 Months Technical Balance', tr_yearly: 'Teknik Denge', en_yearly: 'Technical Balance', value: 'qTecBal' }
            ]
        },
        general: {
            panel1: [
                { tr: 'F/K',  en: 'Price Proceeds', value: 'priceProceeds', type: 'number' },
                { tr: 'PD/DD', en: 'Market Value/Book Value', value: 'marValBookVal', type: 'number' },
                { tr: 'FD/FAVÖK', en: 'Company Value/EBITDA', value: 'coValFavok', type: 'number' },
                { tr: 'FD/Hasılat', en: 'Company Value/Returns', value: 'coValReturns', type: 'number' },
                { tr: 'PD/EFK', en: 'Market Value/EFK', value: 'marValEfk', type: 'number', isPositive: true }
            ],
            panel2: [
                { tr: 'Hasılat', en: 'Returns', value: 'returns' },
                { tr: 'Brüt Kar', en: 'Gross Profit', value: 'grossProfit' },
                { tr: 'Faaliyet Karı', en: 'Operation Profit', value: 'operProfit' },
                { tr: 'FAVÖK', en: 'EBITDA', value: 'favok' },
                { tr: 'Net Kar', en: 'Net Profit', value: 'netProfit' }
            ],
            panel3: [
                { tr: 'Nakit ve Nakit Benzerleri', en: 'Cash and Equivalents', value: 'cashAndEq' },
                { tr: 'Stoklar', en: 'Stocks', value: 'stocks' },
                { tr: 'Dönen Varlıklar', en: 'Current Assets', value: 'curAssets' },
                { tr: 'Duran Varlıklar', en: 'Fixed Assets', value: 'fixAssets' },
                { tr: 'K.V. Yükümlülükler',  en: 'Short Term Liabilities', value: 'shorLiab', isOpposite: true },
                { tr: 'U.V. Yükümlülükler',  en: 'Long Term Liabilities', value: 'longLiab', isOpposite: true },
                { tr: 'A.O. Özkaynaklar', en: 'Equity', value: 'equityParent' }
            ],
            panel4: [
                { tr: 'Brüt Kar Marjı',  en: 'Gross Margin', value: 'grossMargin' },
                { tr: 'Faaliyet Kar Marjı',  en: 'Operation Margin', value: 'operMargin' },
                { tr: 'FAVÖK Marjı',  en: 'EBITDA Margin', value: 'favokMargin' },
                { tr: 'Net Kar Marjı',  en: 'Net Profit Margin', value: 'netMargin' },
                { tr: 'Cari Oran',  en: 'Current Rate', value: 'curRate', type: 'number' },
                { tr: 'Likidite Oranı',  en: 'Liquid Ratio', value: 'liqRatio', type: 'number' },
                { tr: 'Nakit Oranı',  en: 'Cash Ratio', value: 'cashRatio', type: 'number' }
            ],
            panel5: [
                { tr: 'Ort. Aktif Karlılığı', en: 'Avg. Return on Assets', value: 'activeProfit' },
                { tr: 'Ort. Özkaynak Karlılığı', en: 'Avg. Return on Equity', value: 'equityProfit' },
                { tr: 'Net Borç/FAVÖK', en: 'Net Liabilities/EBITDA', value: 'netLiabFavok', type: 'number' },
                { tr: 'YPP/PD', en: 'CP/MV', value: 'curPosMarVal'},
                { tr: 'PEG Oranı', en: 'PEG Ratio', value: 'peg', type: 'number' },
                { tr: 'Kaldıraç Oranı', en: 'Leverage Ratio', value: 'levRatio' },
                { tr: 'Temettü Verimi',  en: 'Dividend Yield', value: 'dividendYield' }
            ],
            charts: [
                { tr: 'Çeyreklik Net Kâr', en: 'Quarter Net Profit', tr_half: '6 Aylık Net Kâr', en_half: '6 Months Net Profit', tr_yearly: 'Net Kâr', en_yearly: 'Net Profit', value: 'qNetProfitAdjusted' },
                { tr: 'Çeyreklik Favök',  en: 'Quarter EBITDA', tr_half: '6 Aylık Favök',  en_half: '6 Months EBITDA', tr_yearly: 'Favök',  en_yearly: 'EBITDA', value: 'qFavokAdjusted' },
                { tr: 'Çeyreklik Hasılat', en: 'Quarter Returns', tr_half: '6 Aylık Hasılat', en_half: '6 Months Returns', tr_yearly: 'Hasılat', en_yearly: 'Returns', value: 'qReturnsAdjusted' }
            ]
        },
    },
    labelDefinition: {
        projectTitle: { tr: 'Temel Analiz Raporu', en: 'Fundamental Analysis Report'},
        projectTitleInsagram: { tr: 'Özet Bilanço ve Gelir Tablosu', en: 'Summary Balance Sheet and Income'},
        reportDate: { tr: 'Rapor Tarihi', en: 'Report Date' },
        panel1Title: { tr: 'ÇARPAN ANALİZİ', en: 'MULTIPLIER ANALYSIS' },
        panel2Title: { tr: 'GELİR TABLOSU', en: 'INCOME STATEMENT' },
        panel3Title: { tr: 'BİLANÇO', en: 'BALANCE SHEET' },
        panel4Title: { tr: 'MARJ & RASYOLAR', en: 'MARGIN & RATIOS' },
        panel5Title: { tr: 'DİĞER VERİLER', en: 'OTHER DATA' },
        share: { tr: 'Paylaş', en: 'Share'},
        exportPdf: { tr: 'PDF Olarak Aktar', en: 'Export To PDF'},
        price: { tr: 'Fiyat', en: 'Price'},
        marketValue: { tr: 'Piyasa Değeri', en: 'Market Value'},
        capital: { tr: 'Sermaye', en: 'Capital'},
        netDebt: { tr: 'Net Borç', en: 'Net Debt'},
        currencyPosition: { tr: 'Net Döviz Pozisyonu', en: 'Net Currency Position'},
        priceGraphic: { tr: 'Fiyat Grafiği', en: 'Price Chart'},
        factoringDescription: {
            tr: '* Faktoring firmalarında sadece yukarıdaki veriler yer almaktadır.',
            en: '* Only the above data are included in factoring companies.'
        },
        curPosNetPeriod: {
            tr: 'Döviz Pozisyonu (Dönem)',
            en: 'Currency Position (Period)'
        },
        inflationAdjustment: {
            tr: 'Enflasyon Düzeltme',
            en: 'Inflation Adjustment'
        },
        inflationAdjustmentInfo: {
            tr: '* Sarı dönem enflasyon düzenlemesini ifade eder.',
            en: '* The yellow period refers to inflation regulation.'
        },
        shareInfo: {
            tr: 'Borsa İstanbul verisidir. Yatırım tavsiyesi değildir.',
            en: 'Borsa İstanbul data. Investment advice is not provided.'
        },
        currency: {
            tr: 'Para Birimi',
            en: 'Currency'
        },
        adjusted: {
            tr: 'Düzeltme',
            en: 'Adjusted'
        },
        adjustedYes: {
            tr: 'Var',
            en: 'Yes'
        },
        adjustedNo: {
            tr: 'Yok',
            en: 'No'
        },
        periods: {
            daily: {
                tr: 'Günlük',
                en: 'Daily'
            },
            weekly: {
                tr: 'Haftalık',
                en: 'Weekly'
            },
            monthly: {
                tr: 'Aylık',
                en: 'Monthly'
            },
            yearly: {
                tr: 'Yıllık',
                en: 'Yearly'
            }
        },
        unadjustedInfo: {
            tr: 'Döviz gösteriminde enflasyon düzeltmesi uygulanmamaktadır.',
            en: 'Inflation adjustment is not applied to currency figures.'
        },
        unadjustedBalanceSheetInfo: {
            tr: 'Bu dönemdeki değerler enflasyon düzeltmesi uygulanmamış verileri içermektedir.',
            en: 'The figures for this period include data that has not been adjusted for inflation.'
        },
        themeToggle: {
            tr: 'Açık tema / koyu tema',
            en: 'Light theme / dark theme'
        },
        language: {
            tr: 'Dil',
            en: 'Language'
        },
        a11ySelected: {
            tr: 'seçili',
            en: 'selected'
        },
        a11yNotSelected: {
            tr: 'seçili değil',
            en: 'not selected'
        },
        appLogo: {
            tr: 'Uygulama logosu',
            en: 'Application logo'
        },
        periodSelect: {
            tr: 'Periyot seç',
            en: 'Select period'
        }
    }
};